import React from 'react';
import {GET_COMMUNES, GET_QUARTIERS, GET_RUES, GET_VILLES} from "../../api/Api";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "./TextField";
import {Field} from "formik";
import {TextField as CoreTextField} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from 'axios';
import {SelectFetch} from "react-select-fetch";
import {AsyncPaginate} from "react-select-async-paginate";
import {generateRandomString} from "../../utils/helpers";

const url = {
    villes: GET_VILLES,
    communes: GET_COMMUNES,
    quartiers: GET_QUARTIERS,
    rues: GET_RUES,
}

const parentFilter = {
    villes: '',
    communes: 'villes',
    quartiers: 'communes'
}

export default function GeoAutocomplete(props) {

    const {type, label,disabled, filters, value, initialSelectedModel, ...otherProps} = props;

    const select = React.useRef(null);
    const [iteration, setIteration] = React.useState(1);

    const [isFocused, setIsFocused] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [cacheId, setCacheId] = React.useState([]);

    const finalFilter = React.useMemo(
        () => {

            let result = {};

            for(let [key, value] of Object.entries(filters || {})){
                result[`${key}[]`] = value
            }

            return result

        },[filters]
    );

    React.useMemo(
        () => {

            if(isFocused)
                return;

            setCacheId(generateRandomString(9))
        },[((filters || {})[parentFilter[type]] || ''), isFocused]
    );

    const finalItems = React.useMemo(()=>{

        if(!items.find(item => item.id == initialSelectedModel?.id))
            return [
                initialSelectedModel,
                ...items
            ].filter(item => !!item)

        return items;

    },[items])

    async function searchItems(search){

        const response = await axios.get(url[type], {
            params: {
                itemsByPage: 45,
                page: 1,
                search,
                selectable: true,
                ...filters
            }
        });

        return {
            options: response.data.data.map(item => {
                return {
                    ...item,
                    label: item.libelle,
                    value: item
                }
            }),
            hasMore: response.data.current_page < response.data.last_page
        }
    }

    return (

        <SelectFetch
            selectRef={select}
            value={value}
            placeholder={'Selectionnez une ou plusieurs entrées'}
            {...otherProps}
            url={url[type]}
            onFocus={(...args)=>{
                setIsFocused(true)
                if(props.onFocus)
                    props.onFocus(...args)
            }}
            onBlur={(...args)=>{
                setIsFocused(false)
                if(props.onBlur)
                    props.onBlur(...args)
            }}
            isDisabled={disabled}
            closeMenuOnSelect={otherProps.closeMenuOnSelect || false}
            loadOptionsOnMenuOpen={true}
            queryParams={{
                itemsByPage: 145,
                page: 1,
                selectable: true,
                ...finalFilter
            }}
            cacheUniqs={cacheId}
            mapResponse={(response) => {
                return {
                    options: response.data.map(item=>({
                        ...item,
                        value: item
                    })),
                    hasMore: response.current_page < response.last_page
                }
            }}
            getOptionLabel={(option)=>{
                return option.libelle
            }}
            styles={{
                indicatorSeparator(){
                    return {
                    }
                },
            }}
        />

    );
}